import { createHashHistory } from "history";
import { parse } from "qs";

export const history = createHashHistory({
  hashType: "slash",
});

export const goTo = (url) => history.push(url);
export const getParams = () =>
  parse((history.location.pathname || "").substr(1));
